// extracted by mini-css-extract-plugin
module.exports = {"custom_select":"Select_custom_select__1iioy","custom_select_arrow":"Select_custom_select_arrow__2wnn2","custom_select_dropdown":"Select_custom_select_dropdown__3Hmti"};